import { Box, Typography, useTheme } from '@material-ui/core';
import { Icon } from '@iconify/react';
import { MouseEvent } from 'react';

type Props = {
  title: string;
  icon: string;
  onClick?: (button: number) => void;
  href?: string;
  target?: string;
};

function ActionButton({ title, icon, onClick, href, target }: Props) {
  const theme = useTheme();

  const handleMouseClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      event.preventDefault();
      onClick(event.button);
    }
  };

  return (
    <Box
      component="a"
      href={href}
      target={target}
      onClick={handleMouseClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        '&:hover .icon-hover': {
          color: theme.palette.primary.main
        }
      }}
    >
      <Box
        className="icon-hover"
        sx={{
          color: theme.palette.grey[600],
          transition: 'color 0.3s ease',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Icon icon={icon} width="20px" />
      </Box>

      <Typography
        noWrap
        textAlign="center"
        variant="body1"
        color={theme.palette.primary.main}
        sx={{
          paddingLeft: '8px',
          paddingBottom: '4px',
          '&:hover': { cursor: 'pointer' }
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}

export default ActionButton;
